import { byCssHtml } from "@de-xima/xima-common-js-dom";
import SimpleBar from "simplebar";
import { findWidgetByVar } from "../common/primefaces-util.ts";

export function scrollChatToBottom(): void {
  const panel = byCssHtml(".messages__list-wrapper");
  if (panel) {
    // See also https://github.com/Grsmto/simplebar/issues/719
    // The package has both a CJS and ESM build. Bundlers use the ESM build, but TypeScript
    // thinks is CJS (due to a missing "type": "module" in their package.json).
    // I.e. TypeScript wants us to write new SimpleBar.default(...), but during
    // runtime, only new SimpleBar(...) works.
    const simpleBarInstance = new SimpleBar(panel);
    const scrollElement = simpleBarInstance.getScrollElement();
    if (scrollElement !== null) {
      scrollElement.scrollTop = scrollElement.scrollHeight;
    }
  }
}

/**
 * Focuses the message editor.
 */
export function focusMessageEditor(): void {
  const editor = findWidgetByVar("messageEditor", PrimeFaces.widget.TextEditor);
  if (editor) {
    const quillEditorInstance = editor.editor;
    if (quillEditorInstance instanceof Quill) {
      quillEditorInstance.focus();
    }
  }
}

export function initQuillEditorAccessibility(): void {
  for (const editor of document.querySelectorAll(".ql-editor")) {
    const placeholder = editor.getAttribute("data-placeholder");
    if (placeholder && !editor.hasAttribute("aria-label")) {
      editor.setAttribute("aria-label", placeholder);
      if (!editor.hasAttribute("role")) {
        editor.setAttribute("role", "textbox");
      }
      editor.setAttribute("aria-multiline", "true");
    }
  }
}
